"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnDList = void 0;
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var style_1 = require("./style");
var DragDropContext = react_beautiful_dnd_1.DragDropContext;
var Draggable = react_beautiful_dnd_1.Draggable;
var Droppable = react_beautiful_dnd_1.Droppable;
var reorder = function (list, startIndex, endIndex) {
    var result = Array.from(list);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
};
var DnDList = function (props) {
    var _a = (0, react_1.useState)([]), items = _a[0], setItems = _a[1];
    (0, react_1.useEffect)(function () {
        setItems(props.list);
    }, [props.list]);
    var onDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        var itm = reorder(items, result.source.index, result.destination.index);
        setItems(itm);
        if (props.onDragAndDrop) {
            props.onDragAndDrop(itm);
        }
    };
    return (react_1.default.createElement(DragDropContext, { onDragEnd: onDragEnd },
        react_1.default.createElement(Droppable, { droppableId: "droppable", direction: props.direction }, function (provided, snapshot) { return (react_1.default.createElement(style_1.DnDListContainer, __assign({}, provided.droppableProps, { ref: provided.innerRef, direction: props.direction, isDragging: snapshot.isDraggingOver, dragColor: props.dragColor, background: props.backgroundColor, margin: props.marginList, padding: props.paddingList, width: props.width, height: props.height }),
            items.map(function (item, index) { return (react_1.default.createElement(Draggable, { key: item.id, draggableId: item.id, index: index }, function (provided) { return (react_1.default.createElement(style_1.DNDItem, __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { margin: props.marginItem, padding: props.paddingItem, draggableStyle: provided.draggableProps.style, style: __assign({}, (provided.draggableProps.style ||
                    {})) }), item.content)); })); }),
            provided.placeholder)); })));
};
exports.DnDList = DnDList;
